import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaSlider from './VaSlider.vue'

export default withConfigTransport(VaSlider)
